import { useSelectionContext } from 'modules/customEvents/contexts';
import {
  FIELD_TABLE_COLUMNS_WITH_BULK_ACTIONS,
  PURCHASE_FIELDS_EMPTY_STATE_CONFIG,
} from 'modules/dataDictionary/constants';
import { usePurchaseMappingsContext } from 'modules/dataDictionary/contexts/PurchaseMappingsContext';
import { useExportFields } from 'modules/dataDictionary/hooks';
import { useFieldTable } from 'modules/dataDictionary/hooks/useFieldTable';
import { ModalAction } from 'modules/dataDictionary/types';
import { createGridLayout } from 'modules/dataDictionary/utils';
import { GenericDataType } from 'modules/domains';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Export24 } from 'ui/icons';
import { useModalContext } from 'utils/contexts/modal';
import { Table, TableBody, TableHeader, TableRow } from '../Table';
import { TableActions } from '../Table/TableActions';
import { TablePagination } from '../Table/TablePagination';

export const PURCHASE_FIELDS_TEXT = {
  tabGroupTestId: 'purchase-fields-tabs-group',
};

export const PurchaseFieldsContent = () => {
  const { showModal } = useModalContext();
  const { selected, toggleSelection } = useSelectionContext();
  const { exportFields } = useExportFields();
  const {
    isErrorPurchaseMappings,
    isLoadingPurchaseMappings,
    purchaseMappings: mappings,
    refetchPurchaseMappings,
  } = usePurchaseMappingsContext();
  const { filteredMappings, objectMappingNames, paginatedMappings } = useFieldTable({ mappings });

  const onCreateNewField = (parentName?: string) =>
    showModal({ action: ModalAction.NEW_PURCHASE_FIELD, payload: { parentName } });

  const gridLayout = createGridLayout();

  return (
    <>
      <TableActions
        dataType={GenericDataType.Purchase}
        onCreateNewField={onCreateNewField}
        overflowMenuOptions={[
          {
            as: AllowedActionMenuElements.Button,
            content: (
              <>
                <Export24 />
                <span>Export purchase fields summary to CSV</span>
              </>
            ),
            id: 'purchase-fields-export',
            onClick: () => exportFields(filteredMappings, 'purchase-field-summary'),
          },
        ]}
        refetchFields={refetchPurchaseMappings}
      />
      <Table>
        <TableHeader
          fieldIds={paginatedMappings.map((field) => field.fieldName)}
          gridLayout={gridLayout}
          columns={FIELD_TABLE_COLUMNS_WITH_BULK_ACTIONS}
        />
        <TableBody
          currentCount={filteredMappings.length}
          emptyStateConfig={PURCHASE_FIELDS_EMPTY_STATE_CONFIG}
          hasError={isErrorPurchaseMappings}
          isLoading={isLoadingPurchaseMappings}
          totalCount={mappings.length}
        >
          {paginatedMappings.map((field) => (
            <TableRow
              key={field.fieldName}
              field={field}
              fieldIds={selected.map((id) => id.toString())} // ensure string property
              gridLayout={gridLayout}
              objectFieldNames={objectMappingNames}
              onCreateNewField={onCreateNewField}
              onSelectRow={() => toggleSelection(field.fieldName)}
            />
          ))}
        </TableBody>
      </Table>
      <TablePagination numItems={filteredMappings.length} />
    </>
  );
};
